import { useForm } from "react-hook-form";
import * as Yup from "yup";
import { yupResolver } from "@hookform/resolvers/yup";

const useCustomValidation = (prop) => {
//   console.log(prop);
  const formSchema = Yup.object().shape(prop.schema);

  const {
    register,
    formState: { errors },
    handleSubmit,
    reset,
    setValue,
  } = useForm({
    defaultValues: prop.initial,
    resolver: yupResolver(formSchema),
  });

  return { register, errors, handleSubmit, reset, setValue };
};

export default useCustomValidation;
